define('core/utils/object/result',[
    'core/utils/lang/isFunction',
], function (
    isFunction
) {
    'use strict';

    // NOTE: Ported from underscore 1.8.3
    return function result(object, property, fallback) {
        var value = object === null || object === void 0 ? void 0 : object[property];
        if (value === void 0)
            value = fallback;
        return isFunction(value) ? value.call(object) : value;
    };
});

